const buildAssetUrl = (asset, width = 1000) => {
    if (!asset) {
        return { type: "", url: "" };
    }

    const { mimeType, handle, url } = asset;
    const isImage = mimeType.indexOf("image/") === 0;
    if (isImage) {
        const mediaUrl = "https://media.graphcms.com";
        const resizeUrl = `${mediaUrl}/resize=w:${width}/${handle}`;
        return { type: "image", url: resizeUrl };
    } else {
        return { type: "video", url };
    }
};

export default buildAssetUrl;



// WEBPACK FOOTER //
// ./src/utils/buildAssetUrl.js